module.exports = __webpack_public_path__ + "static/media/illust03.872f6ad1.png";